// extracted by mini-css-extract-plugin
export default {"tooltip":"ProgressionChartBase_tooltip__vMgC8","download":"ProgressionChartBase_download__iG5cb"};